import { useStringResource } from '@garner-health/lib-ui-content-management';

export type Gender = 'male' | 'female';

export const useGenderOptions = (): { value: Gender; label: string }[] => [
  {
    label: useStringResource('search', 'female'),
    value: 'female',
  },
  {
    label: useStringResource('search', 'male'),
    value: 'male',
  },
];

export const providerTypeFilters = ['app', 'physician'] as const;
export type ProviderTypeFilter = (typeof providerTypeFilters)[number];

export function isProviderTypeFilter(value: string): value is ProviderTypeFilter {
  return (providerTypeFilters as readonly string[]).includes(value);
}

/** `GET /providers` takes a boolean `isApp`; omitting it returns both APPs and physicians. */
export const IS_APP_BY_PROVIDER_TYPE: Record<ProviderTypeFilter, boolean> = { app: true, physician: false };

export const useProviderTypeOptions = (): { value: ProviderTypeFilter; label: string }[] => [
  {
    label: useStringResource('search', 'appsOnly'),
    value: 'app',
  },
  {
    label: useStringResource('search', 'physiciansOnly'),
    value: 'physician',
  },
];

export const languageOptions = [
  { label: 'Arabic', value: 'ara' },
  { label: 'Chinese', value: 'zho' },
  { label: 'English', value: 'eng' },
  { label: 'Filipino', value: 'fil' },
  { label: 'French', value: 'fra' },
  { label: 'German', value: 'deu' },
  { label: 'Hindi', value: 'hin' },
  { label: 'Korean', value: 'kor' },
  { label: 'Russian', value: 'rus' },
  { label: 'Spanish', value: 'spa' },
  { label: 'Vietnamese', value: 'vie' },
];
